<template>
	<v-dialog
		v-model="open"
		width="500"
	>
		<template #activator="{ props }">
			<v-btn
				variant="text"
				v-bind="props"
				color="primary"
			>
				<translate>Edit</translate>
			</v-btn>
		</template>
		<v-card>
			<v-card-title class="d-flex align-center">
				<v-icon
					icon="$translate"
					start
				/>
				{{ editedTranslation.segment }}
			</v-card-title>
			<v-card-text>
				<v-text-field
					v-model:model-value="editedTranslation.translation"
					variant="outlined"
					:label="$gettext('Translation')"
				/>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					variant="text"
					color="error"
					@click="open = false"
				>
					<translate>
						Cancel
					</translate>
				</v-btn>
				<v-btn
					variant="text"
					color="primary"
					@click="save"
				>
					<translate>
						Save
					</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'RouteTranslationDialog',

	props: {
		segmentWithTranslation: {
			type: Object,
			required: true,
		},
		domainName: {
			type: String,
			required: true,
		},
	},

	emits: ['update:segmentWithTranslation',],

	data () {
		return {
			open: false,
			editedTranslation: {
				...this.segmentWithTranslation
			},
		};
	},

	methods: {
		/**
		 * Update or create new supplier
		 */
		async save () {

			await axios.patch('/api/v0/routesegmenttranslations', {
				domainName: this.domainName,
				segmentWithTranslation: this.editedTranslation,
			});

			this.open = false;
			this.$emit('update:segmentWithTranslation', this.editedTranslation);
		}
	}
};
</script>

<style scoped>

</style>
